export default "__VITE_ASSET__DUzlFGej__"